import { gql } from "@apollo/client";

export const UpdateInstalledBaseNotificationSetting = gql`
    mutation UpdateInstalledBaseNotificationSetting ($id: ID!, $input: NotificationSettingAttributesInput!) {
        updateInstalledBaseNotificationSetting(id: $id, input: $input) {
            __typename
            id
            active
            inApp
            mail
            push
        }
    }
`;
